import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeClosed } from '@fortawesome/pro-light-svg-icons';
import MssTooltip from '../../common/MssTooltip';
import { useIsNarrowScreen } from '../../common/useIsNarrowScreen';

function DeckBody({ cards }) {
  const [showDefinitions, setShowDefinitions] = useState(false);
  const isNarrow = useIsNarrowScreen();

  return (
    <Box className="mss__box deckContent">
      <Box className="mss__box cardsList" id="deckDetails__box_cardsList">
        <Box className={`cardsListHeader${showDefinitions ? '' : ' nameOnly'}`}>
          <Typography className="colHeader">Name</Typography>
          {showDefinitions && <Typography className="colHeader">Definition</Typography>}
          <MssTooltip
            id="deckDetails__tooltip_showDefinitions"
            title={showDefinitions ? 'Hide Definitions' : 'Show Definitions'}
            disableHoverListener={!isNarrow}
            disableFocusListener={!isNarrow}
          >
            <Box
              className="showDefinitionsButton"
              id="deckDetails__box_showDefinitions"
              role="button"
              tabIndex={0}
              aria-pressed={showDefinitions}
              onClick={() => setShowDefinitions((current) => !current)}
              onKeyDown={(e) =>
                (e.key === 'Enter' || e.key === ' ') && setShowDefinitions((current) => !current)
              }
            >
              <FontAwesomeIcon
                icon={showDefinitions ? faEyeClosed : faEye}
                className="showDefinitionsIcon"
              />
              <Typography className="showDefinitionsLabel">
                {showDefinitions ? 'Hide Definitions' : 'Show Definitions'}
              </Typography>
            </Box>
          </MssTooltip>
        </Box>

        {(cards ?? []).map((card) => (
          <Box
            key={card.id}
            className={`cardRow${showDefinitions ? '' : ' nameOnly'}`}
            id={`deckDetails__box_card_${card.id}`}
          >
            <Typography className="cardSide">{card.name}</Typography>
            {showDefinitions && (
              <>
                <span className="cardDivider">|</span>
                <Typography className="cardSide">{card.definition}</Typography>
              </>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default DeckBody;
